import {
  broadcast,
  subscribe,
  TEventSubscribeHandler,
  TEventUnsubscribeHandler,
} from '@gem/modules/eventBus';

import { IEvent as ICalendarEvent } from 'APP/model/calendar/calendar.types';

const DELETE_CALENDAR_EVENT_BUS_STATION = 'delete-calendar-event';

export const subscribeDeleteCalendarEvent = (
  callback: TEventSubscribeHandler
): TEventUnsubscribeHandler => {
  return subscribe(DELETE_CALENDAR_EVENT_BUS_STATION, callback);
};

export const broadcastDeleteCalendarEvent = (event: ICalendarEvent): void => {
  broadcast(DELETE_CALENDAR_EVENT_BUS_STATION, event);
};
